import React from 'react'
import { useClientContext } from '../../../../_context/ClientContext';
import { Button, Col, Row } from 'react-bootstrap';
import { ClientType } from '../../../../_models/Client.model';


export const ClientTypeDetails = () => {
  const { client, setClient } = useClientContext();


  const handleClientTypeChange = (value: ClientType) => {
    setClient(client => ({ ...client, Type: value }))
  }



  return (
    <Row>
      <Col sm={12}>
        {Object.keys(ClientType).filter((key) => isNaN(Number(key))).map((key) => {
          const clientTypeEnum = ClientType[key as keyof typeof ClientType];
          const isSelected = client.Type === clientTypeEnum;
          const buttonVariant = isSelected ? 'primary' : 'outline-secondary';

          return (
            <Button
              key={key}
              variant={buttonVariant}
              style={{
                width: "15%",
                minWidth: "120px",
                height: "60px",
                margin: "10px",
                fontWeight: isSelected ? 700 : 500,
                transition: "all 0.2s"
              }}
              onClick={() => handleClientTypeChange(clientTypeEnum)}
            >
              {key}
            </Button>
          );
        })}
      </Col>
    </Row>
  )
}
